import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
  memberName: {
    display: 'flex',
    alignItems: 'center',

    '& > span': {
      marginRight: 5
    }
  },
  memberAdApproverTick: {
    color: theme.brandPrimary
  }
}))

export default useStyles
